import { useState } from 'react';

import styles from './styles.module.scss';

const IntroCard = ({ room, onStart, t }) => {
  const { key, title, intro_short, intro_long } = room;
  const [isExpanded, setIsExpanded] = useState(false);

  const imageUrl = (type) =>
    `${process.env.PUBLIC_URL}/images_iax/intro/${key}.${type}`;

  const renderImage = () => (
    <picture>
      <img src={imageUrl('svg')} alt={title} />
    </picture>
  );

  return (
    <>
      {/* MOBILE  */}
      <div className={`${styles.introCard} ${styles['introCard--mobile']}`}>
        <div className={styles.introCard__bg}></div>
        <div className={styles.introCard__content}>
          {isExpanded && (
            <div className={styles.introCard__image}>{renderImage()}</div>
          )}
          <h5>{t(title)}</h5>
          {isExpanded && <p>{t(intro_short)}</p>}
          <button
            className={`${styles.introCard__button} ${
              styles['introCard__button--secondary']
            } ${isExpanded ? styles['introCard__button--expanded'] : ''}`}
            onClick={() => setIsExpanded(!isExpanded)}
          >
            {t('tool_ui.button.more_info')}
          </button>
          <button onClick={() => onStart('config', room.key, room.title)}>
            {t('tool_ui.button.view_more')}
          </button>
        </div>
      </div>

      {/* DESKTOP  */}
      <div
        key={key}
        className={`${styles.introCard} ${styles['introCard--desktop']}`}
        onClick={() => onStart('config', room.key, room.title)}
      >
        <div className={styles.introCard__bg}></div>
        <div className={styles.introCard__content}>
          <div className={styles.introCard__image}>{renderImage()}</div>
          <div className={styles.introCard__right}>
            <h5>{t(title)}</h5>
            <p>{t(intro_long)}</p>
            <button className={styles.introCard__button}>
              {t('tool_ui.button.view_more')}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default IntroCard;
